import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import { EarningsProgressCard } from '@/modules/payments';
import { RecentSection } from './recent-section';
import { BonusCard } from './bonus-card';
import { BonusProgress } from './bonus-progress';
import { CollectorMotivation } from './collector-motivation';
import { PricingTiersReadonly } from './pricing-tiers-readonly';

function AdminSections({
  targetId,
  creators,
}: {
  targetId: string;
  creators: Creator[];
}): ReactNode {
  return (
    <>
      <BonusCard collectorId={targetId} />
      <RecentSection creators={creators} />
    </>
  );
}

function CollectorSections({ targetId }: { targetId: string }): ReactNode {
  return (
    <>
      <EarningsProgressCard userId={targetId} />
      <BonusProgress userId={targetId} />
      <PricingTiersReadonly />
      <CollectorMotivation collectorId={targetId} />
    </>
  );
}

export function RoleSections({
  isAdmin,
  targetId,
  creators,
}: {
  isAdmin: boolean;
  targetId: string;
  creators: Creator[];
}): ReactNode {
  if (isAdmin) return <AdminSections targetId={targetId} creators={creators} />;
  return <CollectorSections targetId={targetId} />;
}
